export const isAdmin = (user: any) => {
  const userGroups = user?.getSignInUserSession
    ? user?.getSignInUserSession()?.getIdToken().payload['cognito:groups']
    : user?.idToken?.payload['cognito:groups'];
  return userGroups && userGroups.includes('SA_LAB_STAFF');
};
